import { Box, Typography } from "@mui/material";
import React from "react";
import { useStyles } from "./AppStatsItems.styles";
import { ApplicationsStats } from "./ApplicationsStats";
import { useMobile } from "../../../themes";
import {
  CheckCircleOutlineIcon,
  AccessTimeIcon,
  HistoryIcon,
  DoneIcon,
} from "../../../components";

// `#RRGGBB` + alpha → `rgba(...)`. Used for the per-status tinted cornerGlow.
const withAlpha = (hex: string, alpha: number): string => {
  const h = hex.replace("#", "");
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

type TotalItemProps = {
  primaryColor: string;
  secondaryColor: string;
  type: string;
  amount: number | false;
  icon: React.ReactNode;
};

const TotalItem = ({
  primaryColor,
  secondaryColor,
  type,
  amount,
  icon,
}: TotalItemProps) => {
  const classes = useStyles();
  return (
    <Box
      className={classes.totalItem}
      style={{
        background: `radial-gradient(at 100% 0%, ${withAlpha(
          primaryColor,
          0.16,
        )} 0%, transparent 70%), #fff`,
      }}
    >
      <Box
        className={classes.iconTile}
        style={{ backgroundColor: secondaryColor, color: primaryColor }}
      >
        {icon}
      </Box>
      <Box className={classes.content}>
        <Typography className={classes.amount} style={{ color: primaryColor }}>
          {amount || 0}
        </Typography>
        <Typography className={classes.label}>{type}</Typography>
      </Box>
    </Box>
  );
};

export const AppStatsItems = ({ amounts }) => {
  const classes = useStyles();
  const isMobile = useMobile();
  return (
    <Box>
      <Box className={classes.totalAmounts}>
        <TotalItem
          primaryColor={"#2eb662"}
          secondaryColor={"#DCF8E7"}
          type={"New"}
          amount={!!amounts && amounts["New"]}
          icon={<CheckCircleOutlineIcon />}
        />
        <TotalItem
          primaryColor={"#204FFF"}
          secondaryColor={"#D2DCFF"}
          type={"In progress"}
          amount={!!amounts && amounts["In progress"]}
          icon={<AccessTimeIcon />}
        />
        <TotalItem
          primaryColor={"#FFAE00"}
          secondaryColor={"#FFEFCC"}
          type={"Pending"}
          amount={!!amounts && amounts["Pending"]}
          icon={<HistoryIcon />}
        />
        <TotalItem
          primaryColor={"#8D98C2"}
          secondaryColor={"#EEEFF5"}
          type={"Closed"}
          amount={!!amounts && amounts["Closed"]}
          icon={<DoneIcon />}
        />
      </Box>
      <div className={classes.mobileColumns}>
        {isMobile && (
          <Typography variant="h6" className={classes.mobileTitle}>
            Applications statuses
          </Typography>
        )}
        <ApplicationsStats />
      </div>
    </Box>
  );
};
